import React from 'react'
import styles from './FluIndices.module.scss'
import Layout from '../../components/Layout'
import Content from '../../components/Content'
import GeoProvider from '../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import dataDisplayOptions from './dataDisplayOptions'
import { startDate, endDate, displayDate } from './dates'
import Header from './Header'
import Gender from './GenderAgePanel'
import SystemNotification from './../Dashboard/SystemNotification'
const UTIDashboard = () => {
  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={displayDate}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={'metro'}
            >
              <SystemNotification/>
              <Header headerType="NAT" headerNumber={1} />
              <DashboardMap />
              <Gender    geo_type="NAT" geo_id="NAT"  data_type="UTI"/>
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default UTIDashboard
